import RequestService from './RequestService.js';
import AppConfig from '../config/ConfigService.js';
import AuthService from '../auth/AuthService.js'


export default class GlasschainHttpClient {
    // Initializing important variables
    constructor() {
        this.appConfig = new AppConfig();
        this.domain = this.appConfig.getMsaCoreServiceHost(); 
        this.requestService = new RequestService(this.domain);
        this.authService = new AuthService();
    }










    downloadZippedAssets(correlationid) {
        // straight file download
        let loggedInGcid = this.authService.getUser();
        const path = '/api/dashboard/gcid/' + loggedInGcid + '/zipfile/' + correlationid;
        this.requestService.downloadFile(path);
    }


    async fetchUserList(gcid){
        try {
            let gcid = this.authService.getGcid(); 
            const path = '/api/users/gcid/' + gcid + '/gcauthclient';
            //this.requestService.downloadFile(url);
            let responseResult = await this.requestService.fetchJson(path, true);
            console.log("User list Response Result: ");
            console.log(responseResult);
            return responseResult.data;

        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        } 
    }


    async postAddUser(gcid, newUser){
        try {
            var gcid = this.authService.getGcid();
            var encryptor = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
            newUser.scopes.push(gcid);
            //newUser.scopes.push("msacoreapi");
            //newUser.scopes.push("notificationapi");
            var postUser = {
                gcid: gcid,
                encryptorPassword:  encryptor,
                allowOfflineAccess: false,
                accessTokenLifetime: 8000,
                enabled: true,
                clientId: newUser.clientId,
                clientName: newUser.clientName,
                description: newUser.role,
                secret: newUser.password,
                allowedScopes: newUser.scopes,
                allowedLocations: newUser.locations || []
             }
            const path = '/api/users/gcid/' + gcid + '/gcauthclient';
            var postObj = JSON.stringify(postUser);
            console.log("Post Obj:");
            console.log(postObj);
            let responseResult = await this.requestService.postJson(path, postObj, true);
            console.log("Add New User Response Result: ");
            console.log(responseResult);
            return responseResult.data;

        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        } 
    }


    async postUpdateUser(gcid, user)
    {
        try {
            var gcid = this.authService.getGcid();
            var encryptor = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
            user.scopes.push(gcid);
            //newUser.scopes.push("msacoreapi");
            //newUser.scopes.push("notificationapi");
            var postUser = {
                gcid: gcid,
                encryptorPassword:  encryptor,
                allowOfflineAccess: false,
                accessTokenLifetime: 8000,
                enabled: true,
                clientId: user.clientId,
                clientName: user.clientName,
                description: user.role,
                secret: user.password,
                allowedScopes: user.scopes,
                allowedLocations: user.locations || []
             }
            const path = '/api/users/gcid/' + gcid + '/gcauthclient';
            var postObj = JSON.stringify(postUser);
            console.log("Post Obj:");
            console.log(postObj);
            let responseResult = await this.requestService.postJson(path, postObj, true);
            console.log("Updated User Response Result: ");
            console.log(responseResult);
            return responseResult.data;

        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        } 
    }



    async postUpdateUserPassword(gcid, newUser){
        try {
            var gcid = this.authService.getGcid();
            var encryptor = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);
            newUser.scopes.push(gcid);
            newUser.scopes.push("msacoreapi");
            newUser.scopes.push("notificationapi");
            var postUser = {
                gcid: gcid, 
                encryptorPassword:  encryptor,
                allowOfflineAccess: false,
                accessTokenLifetime: 8000,
                enabled: true,
                clientId: newUser.id,
                clientName: newUser.name,
                description: newUser.role,
                secret: newUser.password,
                allowedScopes: newUser.scopes
             }
            const path = '/api/users/gcid/' + gcid + '/gcauthclient';
            var postObj = JSON.stringify(postUser);
            console.log("Post Obj:");
            console.log(postObj);
            let responseResult = await this.requestService.postJson(path, postObj, true);
            console.log("Add New User Response Result: ");
            console.log(responseResult);
            return responseResult.data;

        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        } 
    }

    async postUpdateUserEnabledFlag(gcid, userId, isEnabled){
        try {
            var gcid = this.authService.getGcid();
            const path = '/api/users/gcid/' + gcid + '/gcauthclientenabledflagrequest/id/' + userId + '/enabled/' + isEnabled;
            let responseResult = await this.requestService.postJson(path, "", true);
            console.log("Set Enabled Flag Response Result: ");
            console.log(responseResult);
            return responseResult.data;

        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        }

    }


    async postAddOrgConfigObserver(gcid, newUser){
        try {
            var gcid = this.authService.getGcid();
            var postObserver = {
                id: newUser.id,
                gcid: gcid, 
                fullName: newUser.name,
                title: newUser.role,
                scopes: [],
                locations: []
             }
            const path = '/api/observations/admin/gcid/' + gcid + '/orgconfig/observer';
            var postObj = JSON.stringify(postObserver);
            console.log("Post Obj:");
            console.log(postObj);
            let responseResult = await this.requestService.postJson(path, postObj, true);
            console.log("Add New QA Inspector (Observer) Response Result: ");
            console.log(responseResult);
            return responseResult.data;

        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        }
    }


    async postDeleteOrgConfigObserver(gcid, observerId){
        try {
            var gcid = this.authService.getGcid();
            const path = '/api/observations/admin/gcid/' + gcid + '/orgconfig/observerdeleterequest/id/' + observerId;
            let responseResult = await this.requestService.postJson(path, "", true);
            console.log("Remove QA Inspector (Observer) Response Result: ");
            console.log(responseResult);
            return responseResult.data;

        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        }
    }



    async postAddOrgConfigLocation(gcid, newLocation){
        try {
            var gcid = this.authService.getGcid();
            var postLocation = {
                id: newLocation.id,
                gcid: gcid, 
                name: newLocation.name,
                description: newLocation.description,
                timeZoneDesignator: newLocation.timeZoneDesignator
            }
            const path = '/api/observations/admin/gcid/' + gcid + '/orgconfig/location';
            var postObj = JSON.stringify(postLocation);
            console.log("Post Obj:");
            console.log(postObj);
            let responseResult = await this.requestService.postJson(path, postObj, true);
            console.log("Add New Location Response Result: ");
            console.log(responseResult);
            return responseResult.data;

        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        }
    }


    async postDeleteLocation(gcid, locationId){
        try {
            var gcid = this.authService.getGcid();
            const path = '/api/observations/admin/gcid/' + gcid + '/orgconfig/locationdeleterequest/id/' + locationId;
            let responseResult = await this.requestService.postJson(path, "", true);
            console.log("Location Deleted Response Result: ");
            console.log(responseResult);
            return responseResult.data;

        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        }

    }

    async postUpdateLocationEnabledFlag(gcid, locationId, isEnabled){
        try {
            var gcid = this.authService.getGcid();
            const path = '/api/observations/admin/gcid/' + gcid + '/orgconfig/locationactivationrequest/id/' + locationId + '/active/' + isEnabled;
            let responseResult = await this.requestService.postJson(path, "", true);
            console.log("Set Location Enabled Flag Response Result: ");
            console.log(responseResult);
            return responseResult.data;

        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        }

    }



    async deleteUser(gcid, clientId){
        try {
            let gcid = this.authService.getGcid(); 
            const path = '/api/users/gcid/' + gcid + '/gcauthclientdeleterequest/id/' + clientId;
            //this.requestService.downloadFile(url);
            let responseResult = await this.requestService.postJson(path, "", true);
            console.log("Delete User Response Result: ");
            console.log(responseResult);
            return responseResult.data;

        }
        catch (err) {
            console.log(err);
            throw new Error(err); // stupid. why not just let it flow? We might want to change it, though. 
        } 
    }

    async retireUser(gcid, clientId){
        //
    }



}